// extracted by mini-css-extract-plugin
module.exports = {"deltaproWholeHome":"deltapro-whole-home_deltaproWholeHome__RWvRT"};